import MarqueeComponent from './marquee-component'

const MarqueeInstall = {
  install (Vue) {
    Vue.component('Marquee', MarqueeComponent)
  }
}

export default MarqueeInstall
